var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGirls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9D2131FC-26AC-4DD0-8956-79CAE440F97A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 870,
    height: 1042
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.6%",
    y: "-0.4%",
    width: "101.1%",
    height: "101.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.567963089   0 0 0 0 0.567963089   0 0 0 0 0.567963089  0 0 0 0.298595935 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0956075175 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mini-S",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mini-S-BO-creation-2",
    transform: "translate(-705.000000, -822.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 1280,
    height: 1989
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(355.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-8"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.000000, 299.000000)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.000000, 407.000000)",
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2",
    transform: "translate(0.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 670,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "UI/form/empty+icon-Copy",
    transform: "translate(170.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-form",
    stroke: "#D9DFE5",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 116,
    height: 47,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "label",
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontSize: 13,
    fontWeight: 400,
    "line-spacing": 24,
    fill: "#433C35"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 15
  }, "11")), /*#__PURE__*/React.createElement("g", {
    id: "UI/picto/arrow-drop-down",
    transform: "translate(80.000000, 12.000000)",
    fill: "#748285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7142901,8 C12.8214367,8 13.7142901,7.10714656 13.7142901,6 C13.7142901,4.89285821 12.8214367,4 11.7142901,4 C10.6071483,4 9.71429014,4.89285821 9.71429014,6 C9.71429014,7.10714656 10.6071483,8 11.7142901,8 Z M12.4285791,19.7143044 C12.9821512,19.7143044 13.4285803,19.2678753 13.4285803,18.7143033 L13.4285803,16.2857194 L15.142868,16.2857194 C15.4553684,16.2857194 15.7142973,16.0268001 15.7142973,15.7142997 C15.7142973,15.6071567 15.6875115,15.5089423 15.6339401,15.4196565 L13.4285803,11.7500092 L13.4285803,10.5714364 L13.8303665,10.5714364 L15.8571546,13.6160829 C16.0178691,13.8571546 16.2857265,14.0000119 16.5714412,14.0000119 C17.044656,14.0000119 17.4285851,13.6160829 17.4285851,13.142868 C17.4285851,12.973225 17.3750136,12.8035819 17.2857277,12.6696532 L15.0000107,9.24107768 C14.6428674,8.71429133 14.0892954,8.28571939 13.4285803,8.28571939 L10,8.28571939 C9.3392897,8.28571939 8.78571761,8.71429133 8.42857432,9.24107768 L6.14285731,12.6696532 C6.05357149,12.8035819 6,12.973225 6,13.142868 C6,13.6160829 6.38392903,14.0000119 6.85714388,14.0000119 C7.14285851,14.0000119 7.41071597,13.8571546 7.57143044,13.6160829 L9.59821858,10.5714364 L10,10.5714364 L10,11.7500092 L7.794645,15.4196565 C7.7410735,15.5089423 7.71428776,15.6071567 7.71428776,15.7142997 C7.71428776,16.0268001 7.97321664,16.2857194 8.28571701,16.2857194 L10,16.2857194 L10,18.7143033 C10,19.2678753 10.4553625,19.7143044 11,19.7143044 L12.4285791,19.7143044 Z",
    id: "\\uF182"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirls);
export default __webpack_public_path__ + "static/media/girls.221459ec781f598af2a5bee1b2fbf243.svg";
export { ForwardRef as ReactComponent };